import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // Fails loudly in dev/build rather than silently making requests to `undefined`.
  console.error(
    'Missing VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY. Copy .env.example to .env and fill them in.',
  );
}

// Anon/public key only — this file ships to the browser. Never import the
// service-role key here or anywhere else client-side.
export const supabase = createClient(supabaseUrl, supabaseAnonKey);
